<app-loading *ngIf="contentReady"></app-loading>

<section class="book-service-page"  #pageTop style="margin-bottom: 100px;" *ngIf="!contentReady">
  <div class="book-hero">
    <div>
      <p class="book-kicker">
        {{ isAr ? 'عيادة بلوبوكس ' : 'Blue Box Clinic' }}
      </p>

      <h1>
        {{ isAr ? 'حجز خدمة العيادة' : 'Book Clinic Service' }}
      </h1>

      <p class="book-subtitle">
        {{
          isAr
            ? 'احجز كشف، تطعيم، عملية أو جرومينج بسهولة وسيتم التواصل معك لتأكيد المعاد'
            : 'Book a checkup, vaccine, surgery or grooming service easily'
        }}
      </p>
    </div>

    <div class="hero-badge">
  <img src="/assets/e-commerce/icons/93.webp" style="width: 50px;" alt="العيادة">
      <strong>{{ isAr ? 'حجز سريع' : 'Fast Booking' }}</strong>
    </div>
  </div>

  <div class="book-layout">
    <div class="selected-service-card" *ngIf="service">
<div class="service-icon">
  <svg class="paw-icon" viewBox="0 0 512 512" aria-hidden="true">
    <path
      d="M256 224c-61.9 0-112 50.1-112 112 0 35.3 28.7 64 64 64 18.2 0 34.8-7.6 46.5-19.9 1.9-2 4.9-2 6.8 0C273.2 392.4 289.8 400 308 400c35.3 0 64-28.7 64-64 0-61.9-50.1-112-116-112zM128 192c35.3 0 64-43 64-96S163.3 0 128 0 64 43 64 96s28.7 96 64 96zm256 0c35.3 0 64-43 64-96S419.3 0 384 0s-64 43-64 96 28.7 96 64 96zM224 160c26.5 0 48-35.8 48-80S250.5 0 224 0s-48 35.8-48 80 21.5 80 48 80zm64 0c26.5 0 48-35.8 48-80S314.5 0 288 0s-48 35.8-48 80 21.5 80 48 80z"
    />
  </svg>
</div>

      <p class="small-title">
        {{ isAr ? 'الخدمة المختارة' : 'Selected Service' }}
      </p>

      <h2>{{ serviceTitle }}</h2>

      <p class="service-desc" *ngIf="serviceDescription">
        {{ serviceDescription }}
      </p>

      <div class="service-price" *ngIf="servicePrice">
        <span>{{ isAr ? 'السعر' : 'Price' }}</span>
        <strong>{{ servicePrice }} {{ isAr ? 'جنيه' : 'EGP' }}</strong>
      </div>
    </div>

    <form class="booking-card" [formGroup]="bookingForm" (ngSubmit)="submitBooking()">
      <input type="hidden" formControlName="pet_service_id" />
      <input type="hidden" formControlName="from_website" />

      <div class="form-header">
        <h3>
          {{ isAr ? 'بيانات الحجز' : 'Booking Details' }}
        </h3>

        <p>
          {{
            tokenExists
              ? (isAr ? 'اختار نوع الحيوان والمعاد المناسب فقط' : 'Choose pet type and appointment only')
              : (isAr ? 'اكتب بياناتك ومعاد مناسب للحجز' : 'Enter your details and preferred appointment time')
          }}
        </p>
      </div>

      <div class="logged-user-card" *ngIf="tokenExists">
        <div>
          <strong>{{ isAr ? 'الحجز بحسابك الحالي' : 'Booking with your account' }}</strong>
          <p>
            {{ client_name }} 
            <span *ngIf="phone_number"> - {{ phone_number }}</span>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mb-3">
          <label>
            {{ isAr ? 'نوع الحيوان الأليف' : 'Pet Type' }}
          </label>

          <select class="form-control" formControlName="pet_type">
            <option *ngFor="let type of petTypes" [value]="type.value">
              {{ isAr ? type.ar : type.en }}
            </option>
          </select>

          <div
            class="text-danger mt-1"
            *ngIf="bookingForm.controls['pet_type'].touched && bookingForm.controls['pet_type'].invalid"
          >
            {{ isAr ? 'اختار نوع الحيوان' : 'Choose pet type' }}
          </div>
        </div>

        @if(!tokenExists) {
          <div class="col-md-12 mb-3">
            <label>
              {{ isAr ? 'اسم العميل' : 'Client Name' }}
            </label>

            <input
              class="form-control"
              type="text"
              formControlName="client_name"
              [placeholder]="isAr ? 'اكتب اسمك' : 'Enter your name'"
              [ngClass]="{
                'is-invalid':
                  bookingForm.controls['client_name'].touched &&
                  bookingForm.controls['client_name'].errors,
                'is-valid':
                  bookingForm.controls['client_name'].touched &&
                  !bookingForm.controls['client_name'].errors
              }"
            />

            <div
              class="text-danger mt-1"
              *ngIf="bookingForm.controls['client_name'].touched && bookingForm.controls['client_name'].invalid"
            >
              {{ isAr ? 'اكتب اسمك' : 'Enter your name' }}
            </div>
          </div>

          <div class="col-md-12 mb-3">
            <label>
              {{ isAr ? 'رقم الموبايل' : 'Phone Number' }}
            </label>

            <input
              class="form-control"
              type="text"
              maxlength="11"
              inputmode="numeric"
              pattern="[0-9]*"
              formControlName="phone_number"
              (keypress)="onlyNumbers($event)"
              [placeholder]="isAr ? 'مثال: 01000000000' : 'Example: 01000000000'"
              [ngClass]="{
                'is-invalid':
                  bookingForm.controls['phone_number'].touched &&
                  bookingForm.controls['phone_number'].errors,
                'is-valid':
                  bookingForm.controls['phone_number'].touched &&
                  !bookingForm.controls['phone_number'].errors
              }"
            />

            <div
              class="text-danger mt-1"
              *ngIf="bookingForm.controls['phone_number'].touched && bookingForm.controls['phone_number'].invalid"
            >
              <span *ngIf="bookingForm.controls['phone_number'].errors?.['required']">
                {{ isAr ? 'ادخل رقم الموبايل' : 'Enter phone number' }}
              </span>

              <span
                *ngIf="
                  bookingForm.controls['phone_number'].errors?.['minlength'] ||
                  bookingForm.controls['phone_number'].errors?.['maxlength'] ||
                  bookingForm.controls['phone_number'].errors?.['pattern']
                "
              >
                {{ isAr ? 'ادخل رقم صحيح يبدأ بـ 01' : 'Enter a valid phone number starting with 01' }}
              </span>
            </div>
          </div>
        }

<div class="col-md-12 mb-3">
  <label>
    {{ isAr ? 'ميعاد الحجز' : 'Booking Date' }}
  </label>

  <div
    class="custom-date-field"
    [class.is-invalid-field]="
      bookingForm.controls['booking_date'].touched &&
      bookingForm.controls['booking_date'].errors
    "
  >
<input
  #bookingDatePicker
  class="native-date-picker"
  type="datetime-local"
  formControlName="booking_date"
  [min]="minDate"
/>

    <button
      type="button"
      class="date-display-button"
      [class.placeholder]="!bookingForm.controls['booking_date'].value"
      (click)="openDatePicker(bookingDatePicker)"
    >
      <span>{{ bookingDateDisplay }}</span>
      <span class="date-icon">📅</span>
    </button>
  </div>

  <div
    class="text-danger mt-1"
    *ngIf="bookingForm.controls['booking_date'].touched && bookingForm.controls['booking_date'].invalid"
  >
    {{ isAr ? 'اختار ميعاد الحجز' : 'Choose booking date' }}
  </div>
</div>
      </div>


      <div class="booking-hint">
        <span>📍</span>
              <p>
         {{ "clinicaddresstitle" | transloco }}
         <br>
         {{ "clinicaddress" | transloco }}

        </p>
      </div>
            <div class="booking-hint">
        <span>ℹ️</span>
        <p>
          {{
            isAr
              ? 'بعد إرسال الحجز، فريق Blue Box هيتواصل معاك لتأكيد الميعاد والتفاصيل.'
              : 'After submitting, Blue Box team will contact you to confirm the appointment.'
          }}
        </p>

      </div>
      <button type="submit" class="submit-booking-btn" [disabled]="contentReady">
        {{ isAr ? 'احجز الخدمة الآن' : 'Book Now' }}
      </button>
    </form>
  </div>
</section>